// File: src/config/api.js

const ENV = process.env.REACT_APP_APP_ENV || 'dev';

const CONFIG = {
  dev: {
    apiUrl: process.env.REACT_APP_API_URL || 'https://api.dev.allegoryos.com',
    appUrl: process.env.REACT_APP_APP_URL || 'https://preview-greenscience-web.dev.allegoryos.com'
  },
  prod: {
    apiUrl: process.env.REACT_APP_API_URL || 'https://api.allegoryos.com',
    appUrl: process.env.REACT_APP_APP_URL || 'https://greenscience.ca'
  }
};

const currentConfig = CONFIG[ENV] || CONFIG.dev;

export const API_CONFIG = {
  baseUrl: currentConfig.apiUrl,
  appUrl: currentConfig.appUrl,
  enterpriseId: process.env.REACT_APP_ENTERPRISE_ID,
  environment: ENV,
  siteName: process.env.REACT_APP_SITE_NAME || 'GreenScience Technology'
};

export default API_CONFIG;